import React from "react";
import machine from "../../assets/machine.svg";

export default function MachineLearningIcon({ size }) {
  return <img src={machine} width={size} />;
}
